<app-customer-basic-info [canAutoSave]="false">
</app-customer-basic-info>
